import { render, staticRenderFns } from "./AuthorModalHeader.vue?vue&type=template&id=60c415bf&"
import script from "./AuthorModalHeader.vue?vue&type=script&lang=ts&"
export * from "./AuthorModalHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports